import React from 'react'; // eslint-disable-line

import { withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import { GenericForm } from '../../forms';
import { State } from '../../redux/root-reducer';
import { OnSubmitSuccessProps } from '../../workflow-navigation';
import { Submit, submitAction } from '../actions/submit';
import { ContactPersonDetails } from '../contact-person/contact-person-details';
import CaptureClaimContactDetailsView from '../contact-person/view';
import { FinancialAdviserContactDetails } from '../financial-adviser/financial-adviser-contact-details';
import CaptureBrokerContactDetailsView from '../financial-adviser/view';
import { getContactDetails } from '../reducer';
import { validateContactDetails } from '../validate';
import styles, { StyledComponent } from './styles';

interface Props extends OnSubmitSuccessProps, StyledComponent {
    contactPerson?: ContactPersonDetails;
    financialAdviser?: FinancialAdviserContactDetails;
    submit: Submit;
}

const ContactDetailsForm = GenericForm<{
    contactPerson?: ContactPersonDetails;
    financialAdviser?: FinancialAdviserContactDetails;
}>();
const contactDetailsView: React.FunctionComponent<Props> = ({
    classes,
    contactPerson,
    financialAdviser,
    submit,
    ...rest
}: Props) => {
    return (
        <ContactDetailsForm
            onSubmit={submit}
            initialValues={{
                contactPerson: contactPerson,
                financialAdviser,
            }}
            validate={validateContactDetails}
            {...rest}
        >
            <CaptureBrokerContactDetailsView classes={classes} />
            <CaptureClaimContactDetailsView classes={classes} />
        </ContactDetailsForm>
    );
};

const mapStateToProps = (state: State) => ({
    contactPerson: getContactDetails(state).contactPerson,
    financialAdviser: getContactDetails(state).financialAdviser,
});

const mapDispatchToProps = {
    submit: submitAction,
};

export const ContactDetailsView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(contactDetailsView));
